import { Component, OnInit, Input } from '@angular/core';
import { ExportParameters } from 'src/app/models/export/ExportParameters';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { CryptoService } from 'src/app/services/crypto.service';
import { StorageService } from 'src/app/services/storageService.service';

@Component({
  selector: 'app-export-project-format',
  templateUrl: './export-project-format.component.html',
  styleUrls: ['./export-project-format.component.scss'],
})
export class ExportProjectFormatComponent implements OnInit {

  @Input() public exportParameters: ExportParameters;
  @Input() public inviteLearnersFormatDisabled: boolean;
  @Input() public usageWarningMessages: any;
  @Input() public streamingOptionDisabled: boolean;
  public formats: any[] = [
    { format: 'LMS (Scorm 1.2/2004)', isChecked: true, description: 'This export is compatible with either SCORM 1.2 and SCORM 2004 standards. These are the most commonly supported SCORM standards for modern LMS systems.' },
    { format: 'LMS (xAPI 1.0.3)', isChecked: false, description: 'This export is compatible with the latest experience API update, 1.0.3. If your learning record store is not up to this version, please leave the LRS URL blank to use the eNetReality™ learning record store. *subject to available reporting credits.' },
    { format: 'Web Package', isChecked: false, description: 'Export for your website or software solution outside of a LMS.' },
    { format: 'Invite Learners', isChecked: false, description: 'Send a direct link to your learners to access from eNetReality™.' }
  ];

  constructor(
    public router: Router,
    public modalController: ModalController,
    public cryptoService: CryptoService,
    public storageService: StorageService
  ) { }

  ngOnInit() {
    if (this.exportParameters) {
      for (let index = 0; index < this.formats.length; index++) {
        if (this.formats[index].format != this.exportParameters.exportFormat)
          this.formats[index].isChecked = false;
        else
          this.formats[index].isChecked = true;
      }
    }
  }

  setFormat(event, format: any) {
    this.exportParameters.exportFormat = format.format;

    for (let index = 0; index < this.formats.length; index++) {
      if (this.formats[index].format != format.format)
        this.formats[index].isChecked = false;
    }
  }

  checkFormat(format) {
    format.isChecked = true;
  }

  buyCredits() {
    this.modalController.dismiss();
    if (this.cryptoService.decryptData(this.storageService.getItem("login_r")) == "ad")
      this.router.navigateByUrl('/my-account');
    else
      this.router.navigateByUrl('/contact-admin');
  }
}
